import React, { useState, useEffect, useRef } from 'react';
import { HotelType } from "../../../../backend/src/shared/types";
import HotelCard from './HotelCard';

type Props = {
  hotels: HotelType[];
};

const LastMinuteHotelsList: React.FC<Props> = ({ hotels }) => {
  const [displayedHotels, setDisplayedHotels] = useState<HotelType[]>([]);
  const scrollContainerRef = useRef<HTMLDivElement>(null);

  const updateDisplayedHotels = () => {
    setDisplayedHotels(hotels.filter(hotel => hotel.type.includes('Flash Deals')));
  };

  const scrollLeft = () => {
    if (scrollContainerRef.current) {
      scrollContainerRef.current.scrollBy({
        left: -300,
        behavior: 'smooth',
      });
    }
  };

  const scrollRight = () => {
    if (scrollContainerRef.current) {
      scrollContainerRef.current.scrollBy({
        left: 300,
        behavior: 'smooth',
      });
    }
  };

  useEffect(() => {
    updateDisplayedHotels();
    window.addEventListener('resize', updateDisplayedHotels);

    return () => {
      window.removeEventListener('resize', updateDisplayedHotels);
    };
  }, [hotels]);

  return (
    <>
    {displayedHotels.length === 0 ? '' : 
        <div className="relative flex overflow-hidden w-full p-2 bg-white rounded-lg">
          <button
            className="absolute left-0 top-1/2 transform -translate-y-1/2 p-2 bg-gray-200 rounded-full shadow-md hover:bg-halo-pink hover:text-white transition-colors z-10"
            onClick={scrollLeft}
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M15 19l-7-7 7-7"
              />
            </svg>
          </button>
          <div
            ref={scrollContainerRef}
            className="flex overflow-x-scroll scrollbar-hide space-x-6"
          >
            {displayedHotels.map((hotel) => (
              <div key={hotel._id} className="flex-shrink-0">
                <HotelCard hotel={hotel} />
              </div>
            ))}
          </div>
          <button
            className="absolute right-0 top-1/2 transform -translate-y-1/2 p-2 bg-gray-200 rounded-full shadow-md hover:bg-halo-pink hover:text-white transition-colors"
            onClick={scrollRight}
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M9 5l7 7-7 7"
              />
            </svg>
          </button>
        </div>
      }
    </>
  );
};

export default LastMinuteHotelsList;